import { Box, Checkbox, CircularProgress, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, IconButton, Menu, MenuItem } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { packageSchema } from "../../../schemas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import TablePaginationActions from "../../../base-components/TablePaginationActions";
import CustomModal from "../../../base-components/CustomModal";
import Popup from "../../../base-components/Popup";
import { useNavigate } from "react-router-dom";
import Select from "react-select/base";
import Tooltip from "@mui/material/Tooltip";
import "datejs";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import { getSessionUser, hasAnyPermission, hasPermission, isDynamicStaffRole } from "../../../utils/roleAccess";
import { PageHeader } from "../../../ui";
const BASE_URL = process.env.REACT_APP_BASE_URL;
function Packages() {
  const navigate = useNavigate();
  const [packages, setPackages] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const [pckge, setPckge] = useState({});
  const [packageToDelete, setPackageToDelete] = useState("");
  const [packageToUpdate, setPackageToUpdate] = useState("");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [isSuccessAlert, setIsSuccessAlert] = useState(false);
  const [isFaliureAlert, setIsFailureAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failureMessage, setFailureMessage] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState("");
  const [locations, setLocations] = useState([]);
  const [location, setLocation] = useState();
  const [location_id, setLocationId] = useState("");
  const [company_id, setCompanyID] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);

       // Anchor state for the actions menu
        const [anchorEl, setAnchorEl] = useState(null);
        const [selectedPackage, setSelectedPackage] = useState(null);
        const openAnchor = Boolean(anchorEl);
        const handleClickAnchor = (event, packageId) => {
          setAnchorEl(event.currentTarget);
          setSelectedPackage(packageId);
        };
        const handleCloseAnchor = () => {
          setAnchorEl(null);
          setSelectedPackage(null);
        };


  useEffect(() => {
    const sessionStr = sessionStorage.getItem("user-info");
    if (sessionStr) {
      const session = JSON.parse(sessionStr);
      setRole(session.user.role);
      setCompanyID(session.user.company_id);
      setLocationId(session.user.location_id);
    } else {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    if (role) {
      setLoading(true);
      getPackages();
      getFacilities();
      getLocations();
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [role]);

  async function getLocations() {
    if (!role) return;

    let endpoint = "";
    console.log(role);
    if (role === "SuperAdmin") {
      endpoint = "locations/getLocations";
    } else if (role === "Admin") {
      endpoint = `locations/getLocationsByCompanyID/${company_id}`;
    } else if (role === "ClubAdmin") {
      endpoint = `locations/getLocationsByCompanyID/${company_id}`;
    } else if (isDynamicStaffRole(role)) {
      endpoint = `locations/getLocationsByCompanyID/${company_id}`;
    }

    await fetch(BASE_URL + endpoint)
      .then((response) => response.json())
      .then((data) => {
        console.log(data, "location data");
        setLocations(data.locations);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getFacilities() {
    if (!role) return;

    let endpoint = "";
    console.log(role);
    if (role === "SuperAdmin") {
      endpoint = "facility/getPackageFacilities";
    } else if (role === "Admin") {
      endpoint = `facility/getPackageFacilityByCompanyId/${company_id}`;
    } else if (role === "ClubAdmin") {
      endpoint = `facility/getPackageFacilityByCompanyId/${company_id}`;
    } else if (isDynamicStaffRole(role)) {
      endpoint = `facility/getPackageFacilityByCompanyId/${company_id}`;
    }

    await fetch(BASE_URL + endpoint)
      .then((response) => response.json())
      .then((data) => {
        setFacilities(data.packageFacilities);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getLocationId(id) {
    await fetch(BASE_URL + `locations/getLocationById/${id}`)
      .then((response) => response.json())
      .then((data) => {
        setLocationId(data.location._id);
        setLocation(data.location);
      })
      .catch((error) => console.log(error));
  }

  async function getPackages() {
    if (!role) return;
    setLoading(true);
    let endpoint = "";
    console.log(role);
    if (role === "SuperAdmin") {
      endpoint = `package/getPackages`;
    } else if (role === "Admin") {
      endpoint = `package/getPackagesByCompanyID/${company_id}`;
    } else if (role === "ClubAdmin") {
      endpoint = `package/getPackagesByLocationID/${location_id}`;
    } else if (isDynamicStaffRole(role)) {
      endpoint = `package/getPackagesByLocationID/${location_id}`;
    }
    await fetch(BASE_URL + endpoint)
      .then((response) => response.json())
      .then((data) => {
        setPackages(data.packages);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }

  async function getPackageByID(id) {
    await fetch(BASE_URL + `package/getPackageById/${id}`)
      .then((response) => response.json())
      .then((data) => {
        const filteredFacilities = facilities.filter(fac => data.packages.facilities.includes(fac._id));
        data.packages.facilities = filteredFacilities
        setPckge(data.packages);
        console.log(pckge, "packages");
        setValues({
          title: data.packages.title,
          description: data.packages.description,
          membership_fee: data.packages.membership_fee,
          registration_fee: data.packages.registration_fee ?? "",
          duration: data.packages.duration,
          isFinite: data.packages.isFinite === true,
          durationInDays: data.packages.durationInDays ?? "",
          locationId: data.packages.location_id,
          location_name: data.packages.location_name,
          facilities: data.packages.facilities,
          type:data.packages.type,
          currency:data.packages.currency,
          start_date:data.packages. start_date,
          end_date:data.packages.end_date,
          package_id_temp: data.packages.package_id_temp ?? "",
        });
      })
      .catch((error) => console.log(error));
  }

  const handleAddPackage = async (values, actions) => {
    setButtonLoading(true);
    values.company_id = company_id;
    console.log("Values before sending request:", values);
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    };

    try {
      const response = await fetch(
        BASE_URL + `package/createPackage`,
        requestOptions
      );
      console.log("Response status:", response.status);
      if (!response.ok) {
        console.error("Response not ok:", response);
        const data = await response.json();
        console.error("Response not ok:", data);
        setIsFailureAlert(true);
        setFailureMessage(data.message);
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      } else {
        const responseData = await response.json();
        console.log("Response data:", responseData);
        setIsAddModalOpen(false);
        actions.resetForm();
        getPackages();
        setIsSuccessAlert(true);
        setSuccessMessage("Package added Successfully");
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      }
    } catch (error) {
      console.error("Caught error:", error);
      setIsFailureAlert(true);
      setFailureMessage("Failed to add Package");
      setIsPopupOpen(true);
      setTimeout(() => {
        setIsPopupOpen(false);
      }, 5000);
    } finally {
      setButtonLoading(false);
      // setLoading(false);
    }
  };

  const handleUpdatePackage = async (values, actions) => {
    setButtonLoading(true);
    values.company_id = company_id;
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    };

    try {
      const response = await fetch(
        BASE_URL + `package/updatePackage/${packageToUpdate}`,
        requestOptions
      );

      console.log("Response status:", response.status);
      if (!response.ok) {
        console.error("Response not ok:", response);
        setIsFailureAlert(true);
        setFailureMessage("Failed to Update Package");
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      } else {
        const responseData = await response.json();
        console.log("Response data:", responseData);
        actions.resetForm();
        setIsUpdateModalOpen(false);
        getPackages();
        setIsSuccessAlert(true);
        setSuccessMessage("Package Updated Successfully");
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      }
    } catch (error) {
      console.error("Caught error:", error);
      setIsFailureAlert(true);
      setFailureMessage("Failed to Update Package");
      setIsPopupOpen(true);
      setTimeout(() => {
        setIsPopupOpen(false);
      }, 5000);
    } finally {
      setButtonLoading(false);
      // setLoading(false);
    }
  };

  function deletePackage() {
    setButtonLoading(true);
    const requestOptions = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    };
    fetch(BASE_URL + `package/deletePackage/${packageToDelete}`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        getPackages();
        setIsDeleteModalOpen(false);
        setIsSuccessAlert(true);
        setSuccessMessage("Package deleted Successfully");
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      })
      .catch((error) => {
        console.log(error);
        setIsFailureAlert(true);
        setFailureMessage("Failed to delete Package");
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      }).finally(() => {
        setButtonLoading(false)
      });
  }

  function toggleAddModal() {
    setIsAddModalOpen(!isAddModalOpen);
    resetForm();
  }
  function toggleViewModal() {
    setIsViewModalOpen(!isViewModalOpen);
    resetForm();
  }

  function toggleUpdateModal() {
    setIsUpdateModalOpen(!isUpdateModalOpen);
    resetForm();
  }
  function toggleDeleteModal() {
    setIsDeleteModalOpen(!isDeleteModalOpen);
  }

  function showAddModal(id) {
    setIsAddModalOpen(true);
  }
  function showViewModal(member_package) {
    getPackageByID(member_package._id);
    console.log(member_package, "see package data");
    // setPckge(member_package);
    setIsViewModalOpen(true);
  }
  function showUpdateModal(id) {
    getPackageByID(id);
    setPackageToUpdate(id);
    setIsUpdateModalOpen(true);
  }
  function showDeleteModal(id) {
    setPackageToDelete(id);
    setIsDeleteModalOpen(true);
  }

  const paginatedPackages =
    !packages || packages.length === 0
      ? []
      : rowsPerPage === -1
      ? packages // Show all if "All" option is selected
      : packages.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const {
    values,
    touched,
    errors,
    handleBlur,
    handleChange,
    handleSubmit,
    setValues,
    resetForm,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
      description: "",
      currency: "",
      duration: "",
      isFinite: false,
      durationInDays: "",
      type: "",
      membership_fee: "",
      registration_fee: "",
      start_date: "",
      end_date: "",
      facilities: [],
      locationId: "",
      company_id: "",
      package_id_temp: "",
    },
    validationSchema: packageSchema(isUpdateModalOpen),
    onSubmit: (values, actions) => {
      const isFinite = values.isFinite === true;
      const payload = {
        ...values,
        isFinite,
        durationInDays: isFinite
          ? Number(values.durationInDays)
          : null,
        duration: isFinite
          ? (values.duration || "monthly")
          : values.duration,
        registration_fee:
          values.registration_fee === '' || values.registration_fee == null
            ? 0
            : Number(values.registration_fee),
      };
      console.log("Formik Errors:", errors);
      if (isAddModalOpen) {
        handleAddPackage(payload, actions);
      } else if (isUpdateModalOpen) {
        handleUpdatePackage(payload, actions);
      }
    },
  });
  return (
    <>
      <div className="m-5">
        <PageHeader
          title="Packages"
          actions={
                hasPermission(getSessionUser(), 'packages:create') ? (
                <button
                className="gx-cta"
                onClick={showAddModal}
                >
                Add Package
                </button>
                ) : null
          }
        />
      </div>
      { loading ? (
          
            <div className="flex justify-center items-center mt-20 relative">
              {/* SVG Gradient Definition */}
              <svg width="0" height="0">
                <defs>
                  <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#D71920" />
                    <stop offset="100%" stopColor="#F7931E" />
                  </linearGradient>
                </defs>
              </svg>
      
              {/* Circular Progress with Gradient Stroke */}
              <CircularProgress
                thickness={4}
                size={35}
                sx={{
                  'svg circle': {
                    stroke: 'url(#gradientColors)', // Apply gradient stroke
                  },
                }}
              />
            </div>
          
        ) :  packages && packages.length !== 0 ? (
        <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx m-5 animate-fadeIn overflow-y-auto  overflow-x-auto">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Duration</TableCell>
                <TableCell>Membership Fee</TableCell>
                <TableCell>Registration Fee</TableCell>
                {hasAnyPermission(getSessionUser(), ['packages:update', 'packages:delete']) ? (
                  <TableCell>Actions</TableCell>
                ) : null}
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedPackages?.map((pckge, index) => (
                <TableRow hover key={index}>
                  <TableCell>{pckge.title}</TableCell>
                  <TableCell>{pckge.description}</TableCell>
                  <TableCell>
                    {pckge.isFinite === true
                      ? `${pckge.durationInDays} days`
                      : pckge.duration}
                  </TableCell>
                  <TableCell>{pckge.membership_fee}</TableCell>
                  <TableCell>{pckge.registration_fee}</TableCell>
                  {hasAnyPermission(getSessionUser(), ['packages:update', 'packages:delete']) ? (
                    <TableCell>
                      <div className="flex gap-2">
                        <IconButton onClick={(event) => handleClickAnchor(event, pckge)}>
                          <MoreVertIcon />
                        </IconButton>
                        <Menu anchorEl={anchorEl} open={openAnchor} onClose={handleCloseAnchor}>
                          <MenuItem
                            onClick={() => {
                              handleCloseAnchor();
                              showViewModal(selectedPackage);
                            }}
                          >
                            <FontAwesomeIcon icon={faEye} className='mr-2'/> View
                          </MenuItem>
                          {hasPermission(getSessionUser(), 'packages:update') && (
                          <MenuItem
                            onClick={() => {
                              handleCloseAnchor();
                              showUpdateModal(selectedPackage._id);
                            }}
                          >
                            <FontAwesomeIcon icon={faPen} className='mr-2' /> Update
                          </MenuItem>
                          )}
                          {hasPermission(getSessionUser(), 'packages:delete') && (
                          <MenuItem
                            onClick={() => {
                              handleCloseAnchor();
                              showDeleteModal(selectedPackage._id);
                            }}
                          >
                            <FontAwesomeIcon icon={faTrash} className='mr-2'/> Delete
                          </MenuItem>
                          )}
                        </Menu>
                      </div>
                    </TableCell>
                  ) : null}
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={12}
                  count={packages.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  slotProps={{
                    select: {
                      inputProps: {
                        "aria-label": "rows per page",
                      },
                      native: true,
                    },
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </Box>
      ) : (
        <div className="bg-gx-border w-ful p-3 mt-10 rounded-lg m-10">
          <h3 className="text-xl font-bold text-center text-gx-ink-soft">
            No Records Found
          </h3>
        </div>
      )}

<CustomModal
  isModal={isAddModalOpen || isUpdateModalOpen}
  handleModal={() => {
    if (isAddModalOpen) {
      toggleAddModal();
    } else if (isUpdateModalOpen) {
      toggleUpdateModal();
    }
  }}
  size="2xl"
>
  <h1 className="font-bold text-3xl text-gx-ink-soft p-5 border-b mx-2">
    {isAddModalOpen ? "Add Package" : "Update Package"}
  </h1>
  <form
    onSubmit={handleSubmit}
    className="text-gx-ink-soft m-5"
    autoComplete="off"
  >
    <div>
      <input type="hidden" value={values.company_id} />
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
      <div className="w-full">
        <label>Name <span className='text-red-600'>*</span></label>
        <input
          type="text"
          name="title"
          placeholder="Enter Name"
          value={values.title}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.title && touched.title ? "border-red-600" : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.title && errors.title ? (
          <p className="text-red-500 pl-2 italic">{errors.title}</p>
        ) : null}
      </div>

      <div className="w-full">
        <label className="flex items-center gap-2 mt-6">
          <input
            type="checkbox"
            name="isFinite"
            checked={values.isFinite === true}
            onChange={(e) => {
              const checked = e.target.checked;
              setFieldValue("isFinite", checked);
              if (checked) {
                setFieldValue("duration", values.duration || "monthly");
              } else {
                setFieldValue("durationInDays", "");
              }
            }}
            className="w-4 h-4"
          />
          Finite package (expires after set days, no renewal)
        </label>
      </div>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
      {values.isFinite === true ? (
        <div className="w-full">
          <label>Duration (days) <span className='text-red-600'>*</span></label>
          <input
            type="number"
            name="durationInDays"
            min="1"
            step="1"
            placeholder="e.g. 5"
            value={values.durationInDays}
            className={
              "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
              (errors.durationInDays && touched.durationInDays ? "border-red-600" : "")
            }
            onChange={(e) => {
              handleChange(e);
              const raw = e.target.value;
              const n = Number(raw);
              if (raw !== "" && Number.isInteger(n) && n > 0) {
                setFieldValue("isFinite", true);
              }
            }}
            onBlur={handleBlur}
          />
          {touched.durationInDays && errors.durationInDays ? (
            <p className="text-red-500 pl-2 italic">{errors.durationInDays}</p>
          ) : null}
        </div>
      ) : (
        <div className="w-full">
          <label>Duration <span className='text-red-600'>*</span></label>
          <select
            name="duration"
            placeholder="Enter Duration"
            value={values.duration}
            className={
              "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
              (errors.duration && touched.duration ? "border-red-600" : "")
            }
            onChange={handleChange}
            onBlur={handleBlur}
          >
            <option>Select Duration</option>
            <option value="monthly">Monthly</option>
            <option value="quarterly">Quarterly</option>
            <option value="semi annually">Semi Annually</option>
            <option value="annually">Annually</option>
          </select>
          {touched.duration && errors.duration ? (
            <p className="text-red-500 pl-2 italic">{errors.duration}</p>
          ) : null}
        </div>
      )}
    </div>

    <div className="w-full mt-5">
      <label>Package ID prefix (optional)</label>
      <input
        type="text"
        name="package_id_temp"
        placeholder="e.g. PKG — combined with member number for Package ID"
        value={values.package_id_temp}
        className={
          "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
          (errors.package_id_temp && touched.package_id_temp ? "border-red-600" : "")
        }
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {touched.package_id_temp && errors.package_id_temp ? (
        <p className="text-red-500 pl-2 italic">{errors.package_id_temp}</p>
      ) : null}
    </div>

    <div className="mt-5">
      <label>Description</label>
      <textarea
        type="text"
        name="description"
        placeholder="Enter Description"
        value={values.description}
        className={
          "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
          (errors.description && touched.description
            ? "border-red-600"
            : "")
        }
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {touched.description && errors.description ? (
        <p className="text-red-500 pl-2 italic">{errors.description}</p>
      ) : null}
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
      <div className="w-full">
        <label>Package Type <span className='text-red-600'>*</span></label>
        <select
          name="type"
          placeholder="Enter Package Type"
          value={values.type}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.type && touched.type ? "border-red-600" : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        >
          <option>Select Package Type</option>
          <option value="standard">Standard</option>
          <option value="group">Group</option>
          <option value="addon">Addon</option>
        </select>
        {touched.type && errors.type ? (
          <p className="text-red-500 pl-2 italic">{errors.type}</p>
        ) : null}
      </div>

      {role === "SuperAdmin" || role === "Admin" || role === "ClubAdmin" ? (
        <div className="w-full">
          <label>Location <span className='text-red-600'>*</span></label>
          <select
            name="locationId"
            placeholder="Enter Location"
            value={values.locationId}
            className={
              "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
              (errors.locationId && touched.locationId
                ? "border-red-600"
                : "")
            }
            onChange={handleChange}
            onBlur={handleBlur}
          >
            <option value="" disabled> Locations </option>
            {role === "superAdmin" ? (
              <option value={location?._id}>{location?.name}</option>
            ) : (
              locations?.map((location, index) => (
                <option key={index} value={location._id}>
                  {location.name}
                </option>
              ))
            )}
          </select>
          {touched.locationId && errors.locationId ? (
            <p className="text-red-500 pl-2 italic">{errors.locationId}</p>
          ) : null}
        </div>
      ) : null}
    </div>

    {values.type === "addon" && (
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
        <div className="w-full">
          <label>Start Date:</label>
          <input
            type="date"
            name="start_date"
            placeholder="Start Date"
            value={values.start_date.toString("yyyy-MM-dd")}
            className={
              "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
              (errors.start_date && touched.start_date
                ? "border-red-600"
                : "")
            }
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {touched.start_date && errors.start_date ? (
            <p className="text-red-500 pl-2 italic">{errors.start_date}</p>
          ) : null}
        </div>

        <div className="w-full">
          <label>End Date:</label>
          <input
            type="date"
            name="end_date"
            placeholder="End Date"
            value={values.end_date.toString("yyyy-MM-dd")}
            className={
              "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
              (errors.end_date && touched.end_date
                ? "border-red-600"
                : "")
            }
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {touched.end_date && errors.end_date ? (
            <p className="text-red-500 pl-2 italic">{errors.end_date}</p>
          ) : null}
        </div>
      </div>
    )}
<Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx m-5 animate-fadeIn">
  <h1 className="font-bold text-lg text-gx-ink-soft p-2 border-b">
    Facilities:
  </h1>
  <div className="overflow-x-auto"> {/* Add horizontal scrolling on small screens */}
    <Table className="min-w-full">
      <TableHead>
        <TableRow>
          <TableCell>Facilities Applicable</TableCell>
          <TableCell>Facility Name</TableCell>
          <TableCell>Facility Description</TableCell>
          <TableCell>Facility Fee</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {facilities &&
          facilities.map((facility, index) => (
            <TableRow key={index}>
              <TableCell>
                <Checkbox
                  checked={values.facilities.some(fac => fac._id === facility._id)}
                  onChange={(event) => {
                    const isChecked = event.target.checked;
                    const newFacilities = isChecked
                      ? [...values.facilities, facility]
                      : values.facilities.filter(
                          (fac) => fac._id !== facility._id
                        );

                    setFieldValue("facilities", newFacilities);
                    console.log(values.facilities);
                  }}
                />
              </TableCell>
              <TableCell>{facility.name}</TableCell>
              <TableCell>{facility.description}</TableCell>
              <TableCell>{facility.fee}</TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  </div>
</Box>


    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
      <div className="w-full">
        <label>Membership Fee <span className='text-red-600'>*</span></label>
        <input
          type="number"
          name="membership_fee"
          placeholder="Enter Membership Fee"
          value={values.membership_fee}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.membership_fee && touched.membership_fee
              ? "border-red-600"
              : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.membership_fee && errors.membership_fee ? (
          <p className="text-red-500 pl-2 italic">
            {errors.membership_fee}
          </p>
        ) : null}
      </div>

      <div className="w-full">
        <label>Registration Fee</label>
        <input
          type="number"
          name="registration_fee"
          placeholder="Enter Registration Fee"
          value={values.registration_fee}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.registration_fee && touched.registration_fee
              ? "border-red-600"
              : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.registration_fee && errors.registration_fee ? (
          <p className="text-red-500 pl-2 italic">
            {errors.registration_fee}
          </p>
        ) : null}
      </div>
    </div>

    <div className="w-full mt-5">
      <label>Currency</label>
      <select
        name="currency"
        placeholder="Select Currency"
        value={values.currency}
        className={
          "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
          (errors.currency && touched.currency ? "border-red-600" : "")
        }
        onChange={handleChange}
        onBlur={handleBlur}
      >
        <option>Select Currency</option>
        <option value="usd">US Dollars (USD)</option>
        <option value="aed">UAE Dirhams (AED)</option>
        <option value="rs">Pakistani Rupees (RS)</option>
      </select>
      {touched.currency && errors.currency ? (
        <p className="text-red-500 pl-2 italic">{errors.currency}</p>
      ) : null}
    </div>

    <div className="flex justify-end items-center pt-3 mt-3 border-t">
      <button
        type="submit"
        className={`flex bg-blue-600 p-2 px-5 rounded-lg text-white font-medium hover:bg-blue-700 ${buttonLoading ? "cursor-not-allowed bg-gray-400" : ""}`}
        disabled={buttonLoading}
      >
        {buttonLoading ? "Submitting..." : "Submit"}
        {buttonLoading && (
          <CircularProgress
            size={20}
            className="ml-2 mt-1"
            sx={{ color: "white" }}
          />
        )}
      </button>
    </div>
  </form>
</CustomModal>
<CustomModal
  isModal={isViewModalOpen}
  handleModal={toggleViewModal}
  size="2xl"
>
  
    <div>
      <Tooltip title="" placement="bottom">
        <h1 className="font-bold text-3xl text-gx-ink-soft p-5 border-b mx-2">
          View Packages
        </h1>
        <div className="m-5 sm:m-8 md:m-14">
          <Box className="overflow-x-auto"> {/* Make the Box scrollable */}
            <Table className="min-w-full">
              <TableBody>
                <TableRow>
                  <TableCell className="font-medium">Name</TableCell>
                  <TableCell>{pckge.title}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium">Package ID prefix</TableCell>
                  <TableCell>{pckge.package_id_temp || "—"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium">Description</TableCell>
                  <TableCell>{pckge.description}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium">Duration</TableCell>
                  <TableCell>
                    {pckge.isFinite === true
                      ? `${pckge.durationInDays} days`
                      : pckge.duration}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium">Membership Fee</TableCell>
                  <TableCell>{pckge.membership_fee}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium">Registration Fee</TableCell>
                  <TableCell>{pckge.registration_fee}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium">Facilities</TableCell>
                  <TableCell>
                      <div className="flex justify-center items-center">
                      {
                      pckge?.facilities?.map((fac , index) => (
                        <div key={index} className="pl-1">
                          {fac.name} ||
                        </div>
                      )) 
                      }
                      </div>
                      </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium">Location</TableCell>
                  <TableCell>{pckge.location_id}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium">Currency</TableCell>
                  <TableCell>{pckge.currency}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </div>
      </Tooltip>
    </div>
  
</CustomModal>

      {isPopupOpen && (
        <Popup
          onClose={() => setIsPopupOpen(false)}
          alertType={
            isSuccessAlert ? "success" : isFaliureAlert ? "failure" : ""
          }
          message={
            isSuccessAlert
              ? successMessage
              : isFaliureAlert
              ? failureMessage
              : ""
          }
        />
      )}

      <CustomModal
        isModal={isDeleteModalOpen}
        handleModal={toggleDeleteModal}
        size="md"
      >
        <div className="m-5">
          <h2 className="text-xl font-medium">Delete Package?</h2>
          <p className="text-gx-ink-soft mt-3">
            Are you sure you want to delete this package?
          </p>
          <button
            className={`flex bg-red-600 p-2 px-5 rounded-lg text-white font-medium hover:bg-red-700 mt-5 float-right mb-5 ${buttonLoading ? "cursor-not-allowed bg-gray-400" : ""}`}
            onClick={deletePackage}
            disabled={buttonLoading}
          >
            {buttonLoading ? "Deleting..." : "Delete"}
            {buttonLoading && (
              <CircularProgress
                size={20}
                className="ml-2 mt-1"
                sx={{ color: "white" }}
              />
            )}
          </button>
        </div>
      </CustomModal>
    </>
  );
}

export default Packages;
